import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";

const KEY = "zw-cookie-hinweis-ok";

/** Minimaler Datenschutz-Hinweis – keine Tracker, kein Consent-Tool nötig */
export default function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(KEY, "1");
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-20 md:bottom-4 left-3 right-3 sm:left-4 sm:right-auto sm:max-w-md z-[60] bg-white border border-[#D7E5D9] rounded-xl shadow-xl p-4 animate-in"
      role="dialog"
      aria-label="Cookie- und Datenschutzhinweis"
      data-testid="cookie-notice"
    >
      <div className="flex items-start gap-3">
        <Cookie className="w-5 h-5 text-[#1E5631] shrink-0 mt-0.5" aria-hidden="true" />
        <div className="space-y-2">
          <p className="text-xs text-[#4A634E] leading-relaxed">
            <strong className="text-[#122B18]">Datenschutz leicht gemacht:</strong> Diese Website verwendet keine
            Tracking-Cookies und keine Analyse-Tools. Es werden nur technisch notwendige Daten verarbeitet. Details
            finden Sie in der Datenschutzerklärung.
          </p>
          <button
            onClick={accept}
            data-testid="cookie-accept-button"
            className="bg-[#1E5631] hover:bg-[#154023] text-white text-xs font-bold px-4 py-2 rounded-md transition-colors"
          >
            Verstanden
          </button>
        </div>
      </div>
    </div>
  );
}
